import React from 'react';
import { ZapIcon, ShieldCheckIcon, InfinityIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const trust = [{
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime access'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function Hero() {
  return <header className="w-full bg-ink-900" data-id="element-186" data-mp="qvm6ko0i2sam">
      <div className="w-full bg-ember px-4 py-2.5 text-center" data-id="element-187" data-mp="qub3kqevpokk">
        <p className="font-display text-[13px] font-extrabold uppercase tracking-[0.12em] text-white sm:text-base" data-id="element-188" data-mp="vmm0rli8iw9f">
          Launch offer · Lifetime access for only $27 USD
        </p>
      </div>

      <div className="mx-auto w-full max-w-3xl px-4 pb-14 pt-8 sm:px-6 sm:pt-12" data-id="element-189" data-mp="15ks509rikehg">
        <p className="text-center font-display text-lg font-bold uppercase tracking-[0.4em] text-zinc-400" data-id="element-190" data-mp="1ajmkp2u6pmxc">
          Weld
        </p>
        <h1 className="mt-1 text-center font-display text-[40px] font-extrabold uppercase leading-[0.92] tracking-tight text-white sm:text-7xl" data-id="element-191" data-mp="9o2pjkgwyomj">
          Decision <span className="text-flame-500" data-id="element-192" data-mp="4r2lff3mjvy2">System</span>
          <span className="align-super text-base sm:text-2xl" data-id="element-193" data-mp="3vvskj0jzqbhi">™</span>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-center font-display text-[22px] font-bold uppercase leading-[1.15] text-spark sm:text-3xl" data-id="element-194" data-mp="3ru7dvwy1utfr">
          Stop guessing what to do next. Diagnose your weld in less than 3 minutes and follow a clear
          next step.
        </p>

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-zinc-300 sm:text-lg" data-id="element-195" data-mp="io90ayl89ai0">
          The practical visual decision-making system designed to help beginner and intermediate
          welders know what to check, what to look for and what to correct — without jumping between
          endless YouTube videos.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/9RryBkmz3WAQnjQyvw72KZ/WELD-EN.png" alt="Weld Decision System™ complete digital package: 6 master volumes shown on box, tablet and phone" className="mx-auto mt-6 w-full max-w-[560px]" width={1080} height={1080} data-id="element-196" data-mp="16cif3gk0wxzn" />

        <p className="mt-2 text-center font-display text-base font-extrabold uppercase leading-snug tracking-wide text-white sm:text-xl" data-id="element-197" data-mp="2qu9qgl9l1g11">
          6 Master Volumes + 5 Exclusive Bonuses + Instant Digital Access
        </p>

        <div className="mt-7" id="first-cta" data-id="element-198" data-mp="2mv23kucvfnrj">
          <CTAButton sub="" data-id="element-199" data-mp="2mvty01uqffg8" />
        </div>

        <div className="mt-6" data-id="element-200" data-mp="27xi23xf6oaq4">
          <Countdown data-id="element-201" data-mp="27yjq12hasrp9" />
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-2.5" data-id="element-202" data-mp="27zcl366w9srk">
          {trust.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 rounded-lg border border-ink-600 bg-ink-800 px-3 py-2.5" data-id="element-203" data-mp="2cy61b6dkfxvf">
              <Icon className="h-4 w-4 shrink-0 text-flame-400" aria-hidden="true" data-id="element-204" data-mp="b4g7tlbc4hdc" />
              <span className="text-[12px] font-semibold leading-tight text-zinc-200 sm:text-sm" data-id="element-205" data-mp="1vo25a7nwixke">
                {label}
              </span>
            </li>)}
        </ul>

        <div className="mt-6" data-id="element-206" data-mp="25d3k3uipn8ws">
          <ScarcityBar data-id="element-207" data-mp="25eembpwic8ls" />
        </div>
      </div>
    </header>;
}